// API Helper
export const API_HELPER = {
  apiGET: async (url) => {
    const response = await fetch(url);
    const text = await response.text();
    try { return text ? JSON.parse(text) : { status: response.status }; } catch(e) { return { status: response.status, data: text }; }
  },
  apiPOST: async (url, data) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    const text = await response.text();
    try { return text ? JSON.parse(text) : { status: response.status }; } catch(e) { return { status: response.status, data: text }; }
  },
  apiPOST_Multipart: async (url, formData) => {
    const response = await fetch(url, {
      method: 'POST',
      body: formData,
    });
    const text = await response.text();
    try { return text ? JSON.parse(text) : { status: response.status }; } catch(e) { return { status: response.status, data: text }; }
  },
  apiPUT: async (url, data) => {
    const response = await fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    const text = await response.text();
    try { return text ? JSON.parse(text) : { status: response.status }; } catch(e) { return { status: response.status, data: text }; }
  },
  apiPUT_Multipart: async (url, formData) => {
    const response = await fetch(url, {
      method: 'PUT',
      body: formData,
    });
    const text = await response.text();
    try { return text ? JSON.parse(text) : { status: response.status }; } catch(e) { return { status: response.status, data: text }; }
  },
  apiDELETE: async (url) => {
    const response = await fetch(url, {
      method: 'DELETE',
    });
    
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      return response.json();
    } else {
      return { status: response.status, data: { message: "Deleted successfully" } };
    }
  },
};

